import {
  FETCH_INVENTORY_REQUEST,
  FETCH_INVENTORY_SUCCESS,
  FETCH_INVENTORY_FAILURE,
  FETCH_INVENTORY_RESET,
  SET_INVENTORY_FROM_CACHE
} from '../constants';

const initialState = {
  inventoryRequest: false,
  inventoryData: {},
  inventoryStatus: false
};

interface stateType {
  inventoryRequest: boolean;
  inventoryData: Object;
  inventoryStatus: boolean;
}

interface actionType {
  type: string;
  payload?: {
    data?: Object;
    error?: string;
  };
}

export const inventoryReducer = (state = initialState, action: actionType): stateType => {
  switch (action.type) {
    case FETCH_INVENTORY_REQUEST:
      return {
        ...state,
        inventoryRequest: true,
        inventoryData: {},
        inventoryStatus: false
      };
    case FETCH_INVENTORY_SUCCESS:
      return {
        ...state,
        inventoryRequest: false,
        inventoryData: action.payload?.data || {},
        inventoryStatus: true
      };
    case FETCH_INVENTORY_FAILURE:
      return {
        ...state,
        inventoryRequest: false,
        inventoryData: {},
        inventoryStatus: false
      };
    case FETCH_INVENTORY_RESET:
      return initialState;
    case SET_INVENTORY_FROM_CACHE:
      return {
        ...state,
        inventoryData: action.payload?.data || {},
      };
    default:
      return state;
  }
};
